<template>
 <div class="consent_wrapper"></div>
</template>

<script>
import { mapGetters } from 'vuex'
import privacySettings from '@/mixins/privacySettings'
import cookie from '@/mixins/cookie'
const PRIVACY_DIR = 'privacysettings'
export default {
    name: 'PrivacySettings',
    mixins: [
        privacySettings,
        cookie
    ],
    data() {
        return {
            analytics: false,
            userPreferences: false,
            marketing: false,
            hide_statistics_hint: true,
            hide_userpref_hint: true,
            hide_marketing_hint: true,
            CookieStripShown: false,
            COOKIE_SETTING_NAME: `ubs_cookie_settings_${process.env.VUE_APP_COOKIES_VERSION}`
        }
    },
    computed: {
        ...mapGetters('app', [
            'cookieSettings',
            'isCookieSettingsPresent'
        ])
    },
    created() {
        window.cookie_management = `${process.env.BASE_URL}${PRIVACY_DIR}/partials/privacySettings__Lightbox__${this._i18n.i18next.language}.html`
        window.cookie_management_privacyPolicy = 'STRICT'
        this.loadCookieBanner()
    },
    mounted() {
        this.initCookieSettings()
    },
    methods: {
        loadScript(scriptUrl) {
            return new Promise((resolve) => {
                const script = document.createElement('script')
                script.onload = () => {
                    return resolve(true)
                }
                script.src = scriptUrl
                window.document.body.appendChild(script)
            })
        },
        loadCookieBanner() {
            this.getContents(`${process.env.BASE_URL}${PRIVACY_DIR}/partials/privacySettings__Banner__${this._i18n.i18next.language}.html`).then((html) => {
                html = html.replace('__BASE_URL__', process.env.BASE_URL)
                document.querySelector('.consent_wrapper').innerHTML = html
                this.loadScript(`${process.env.BASE_URL}${PRIVACY_DIR}/js/script.js`)
            })
        }
    }
}
</script>
